'use client'

import type { FC } from 'react'

import { Card } from '@circlefin/components'
import { type ResultItemProps } from '@features/algolia.modals/Search/ResultItem/ResultItem'

export const SearchResultItem: FC<ResultItemProps> = ({
  title,
  description,
  href,
}) => {
  return (
    <Card className="min-h-48">
      <Card.Content className="grow overflow-hidden">
        <a
          className="flex size-full flex-col gap-3"
          href={href}
          rel="noreferrer noopener nofollow"
          target="_blank"
        >
          <span
            dangerouslySetInnerHTML={{ __html: title }}
            className="line-clamp-2 type-body-base-bold"
          />
          <span
            dangerouslySetInnerHTML={{ __html: description }}
            className="type-body-sm"
          />
        </a>
      </Card.Content>
    </Card>
  )
}
